import { asset } from "@/lib/asset";
import { Link } from "react-router-dom";
import semi_circle_x2 from "@/assets/icons/semi-circle-x2.svg";
import merge_down from "@/assets/icons/merge-down.svg";
import left_wind_in from "@/assets/icons/left-wind-in.svg";
import lightning_cross from "@/assets/icons/lightning-cross.svg";
import recycle from "@/assets/icons/recycle.svg";
import triangles_2 from "@/assets/icons/triangles-2.svg";
import hexa_recycle from "@/assets/icons/hexa-recycle.svg";

const footer_nav = [
  {
    title: "Главная",
    to: "/",
    links: [
      { text: "О нас", to: "/about", icon: semi_circle_x2 },
      { text: "Карьера", to: "/career", icon: merge_down },
      {
        text: "Поддержка",
        to: "/support/",
        icon: left_wind_in,
        target: "_blank",
      },
      {
        text: "Политика конфеденциальности",
        to: "/privacy",
        icon: lightning_cross,
      },
      { text: "Условия обслуживания", to: "/terms", icon: recycle },
      // { text: "Обучение", to: "/education/", icon: triangles_2 },
      // { text: "Информация о лицензировании", to: "/static/docs/license-agreement-with-end-user.pdf", icon: hexa_recycle },
    ],
  },
  {
    title: "Продукт APM",
    to: "/technologies",
    links: [
      {
        text: "Мониторинг контейнеров",
        to: "/apm/containers",
        icon: semi_circle_x2,
      },
      { text: "Мониторинг DevOps", to: "/apm/devops", icon: merge_down },
      { text: "SLO", to: "/apm/slo", icon: left_wind_in },
      { text: "Мониторинг приложений", to: "/apm/apps", icon: lightning_cross },
      // { text: "Инженерия надежности сайтов (SRE)", to: "/apm/sre", icon: recycle },
      // { text: "Управление и аналитикa журналов", to: "/apm/logs", icon: triangles_2 },
      {
        text: "Поддерживаемые технологии",
        to: "/supported-technologies",
        icon: hexa_recycle,
      },
      { text: "Наблюдаемость приложений", to: "/apm/apps", icon: hexa_recycle },
      {
        text: "Наблюдаемость инфраструктуры",
        to: "/apm/infra",
        icon: hexa_recycle,
      },
      { text: "Мониторинг базы данных", to: "/apm/db", icon: hexa_recycle },
      { text: "Мониторинг сети", to: "/apm/network", icon: hexa_recycle },
      // { text: "Безопасность приложений", to: "/apm/security", icon: hexa_recycle },
      // { text: "Искуственный интеллект для ИТ-операций (AIOps)", to: "/apm/aiops", icon: hexa_recycle },
      { text: "Мониторинг 1C", to: "/blog/1c-support", icon: hexa_recycle },
    ],
  },
  {
    title: "Кейсы",
    to: "/cases",
    links: [
      {
        text: "Общая Презентация",
        to: "/static/docs/AstromKey.pdf",
        icon: lightning_cross,
        target: "_blank",
      },
      // { text: "СМИ", icon: semi_circle_x2 },
      // { text: "Истории клиентов", icon: merge_down },
      // { text: "Клиенты о нас", icon: left_wind_in },
      // { text: "Презентация для ИТ- отдела", icon: recycle },
    ],
  },
  {
    title: "Цена",
    to: "/cenoobrazovanie",
    links: [
      {
        text: "On-premises решение",
        to: "/cenoobrazovanie/#on-premises",
        icon: semi_circle_x2,
      },
      {
        text: "SaaS платформа",
        to: "/cenoobrazovanie/#saas",
        icon: merge_down,
      },
    ],
  },
  {
    title: "Блог",
    to: "/blog",
    links: [
      { text: "Блог", to: "/blog", icon: semi_circle_x2 },
      {
        text: "Сравнение с Open Source",
        to: "https://vc.ru/u/952799-ruskomtehnologii/568542-sravnenie-promyshlennogo-apm-i-open-source-reshenii",
        icon: merge_down,
        target: "_blank",
      },
      {
        text: "Ключ-АСТРОМ в Telegram",
        to: "https://t.me/+08LGstzgbIUwOGEy",
        icon: triangles_2,
        target: "_blank",
      },
    ],
  },
];

function Footer() {
  return (
    <footer className="relative bg-gradient-to-r from-[#202020] via-[#352f2a] to-[#ecb07b] overflow-hidden">
      <div className="px-4 sm:px-16">
        <div className="container mx-auto">
          {/* Logo + navigation columns */}
          <div className="flex flex-col gap-10 pt-[60px] xl:flex-row">
            <Link to="/" className="shrink-0 self-start">
              <img
                className="h-[106px] w-[166px]"
                src={asset("/img/ka.svg")}
                alt="Ключ-АСТРОМ"
              />
            </Link>

            <nav className="grid flex-1 grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
              {footer_nav.map((col) => (
                <FooterColumn key={col.title} {...col} />
              ))}
            </nav>
          </div>

          {/* Copyright */}
          <div className="w-full my-20">
            <div className="flex flex-col-reverse lg:flex-row justify-between items-start lg:items-start xl:items-end">
              <div className="flex-col text-white lg:text-left text-[12px] lg:text-[16px] font-normal font-['Open Sans'] w-full max-w-full sm:max-w-[340px] md:max-w-full lg:max-w-full my-[68px] lg:my-0 xl:pb-[28px] justify-between items-end h-full gap-[32px] flex-wrap">
                <div className="mb-6">
                  Код вида деятельности в области ИТ (Приказ Минцифры России от
                  11.05.2023 г. № 449): 2.01
                </div>

                <div className="mb-6">
                  Данные о наличии исключительных прав на ПО и базы данных:{" "}
                  <br />
                  <a
                    href="https://ruscomtech.ru/static/docs/Регистрация_программы.pdf"
                    target="_blank"
                    className="underline"
                  >
                    {" "}
                    Свидетельство о государственной регистрации программы для
                    ЭВМ №2017614533 Ключ-АСТРОМ
                  </a>
                  , правообладатель - ООО Рускомтехнологии. <br />
                  <br />
                  <a
                    href="/static/docs/ip-ka.pdf"
                    target="_blank"
                    className="underline"
                  >
                    {" "}
                    Свидетельство на товарный знак №606227 Ключ-АСТРОМ
                  </a>
                  , правообладатель - ООО Рускомтехнологии.
                </div>

                <div className="mt-auto">
                  © 2026 Все права защищены. Включена в Единый{" "}
                  <br className="lg:hidden" /> реестр российских программ для
                  ЭВМ и баз данных. <br className="md:hidden" />{" "}
                  <a
                    href="https://reestr.digital.gov.ru/reestr/305529/?sphrase_id=6808322"
                    target="_blank"
                    className="underline"
                  >
                    Запись №4179 от 11.12.2017
                  </a>
                  , Произведена на основании приказа Министерства цифрового
                  развития, связи и массовых коммуникаций Российской Федерации
                  от 07.12.2017 №680.
                </div>
              </div>

              <div className="flex flex-col xl:flex-col gap-4 items-start xl:items-end xl:mt-[-80px] w-full max-w-[300px] lg:pl-16">
                <div className="flex flex-col xl:gap-0 lg:text-left xl:text-right w-full">
                  <span className="text-white text-[16px] font-normal font-['Open Sans']">
                    ООО "Рускомтехнологии"
                  </span>

                  <span className="text-white text-[16px] font-normal font-['Open Sans']">
                    ИНН 7716786067 ОКВЭД 62.01
                  </span>
                  <span className="text-white text-[16px] font-normal font-['Open Sans']">
                    КПП 771701001
                  </span>
                  <span className="text-white text-[16px] font-normal font-['Open Sans']">
                    ОГРН 5147746162086
                  </span>

                  <br />
                  <div className="">
                    <a
                      href="tel:+74956651536"
                      className="text-white text-[16px] font-normal font-['Open Sans']"
                    >
                      Связаться с нами
                      <br className="hidden lg:block" />+ 7 (495) 665 15 36
                      <br />
                    </a>
                    <a
                      href="tel:+74956655132"
                      className="text-white text-[16px] font-normal font-['Open Sans']"
                    >
                      Тех поддержка
                      <br className="hidden lg:block" /> + 7 (495) 665 51 32
                      <br />
                    </a>
                  </div>
                </div>

                <div className="flex flex-col xl:gap-0 xl:text-right w-full">
                  <span className="text-white text-[16px] font-normal font-['Open Sans']">
                    129626, г. Москва,
                    <br className="hidden lg:block" />
                    проспект Мира, д.102,
                    <br className="" />
                    корп.1, комн.12
                  </span>
                  <a
                    href="mailto:info@ruscomtech.ru"
                    className="text-white text-[16px] font-normal font-['Open Sans'] underline"
                  >
                    info@ruscomtech.ru
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, to, links }) {
  return (
    <div className="flex flex-col gap-[22px]">
      <Link
        to={to}
        className="text-white text-[16px] font-bold font-['Open Sans'] hover:underline"
      >
        {title}
      </Link>
      <ul className="flex flex-col gap-[15px]">
        {links.map((link) => (
          <li key={link.text}>
            <FooterLink {...link} />
          </li>
        ))}
      </ul>
    </div>
  );
}

function FooterLink({ text, to = "/", icon = null, target = "_self" }) {
  const className =
    "flex items-start gap-[7px] text-white text-[16px] xl:text-[12px] font-medium xl:font-bold font-['Open Sans'] hover:underline";
  const content = (
    <>
      {icon && (
        <img
          src={icon}
          alt=""
          className="mt-[5px] w-auto shrink-0 brightness-0 invert xl:mt-[3px]"
        />
      )}
      <span>{text}</span>
    </>
  );
  if (to.startsWith("http")) {
    return (
      <a
        href={to}
        target={target}
        rel="noopener noreferrer"
        className={className}
      >
        {content}
      </a>
    );
  }
  return (
    <Link to={to} target={target} className={className}>
      {content}
    </Link>
  );
}

export default Footer;
